import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { shortDate } from "LIB/formatters/date";
import { dollars } from "LIB/formatters/currency";
import { CANCELLATION_REASONS } from "MODULES/Orders/shared/constants";
import RecordPager from "MODULES/shared/components/RecordPager/RecordPager";
import { ClipboardCopy, StatusTag } from "MODULES/shared/components";
import { CANCELLED, CODE, CREATED_AT, LINE_ITEMS } from "APP_ROOT/constants";
import { ACCOUNTING_HOLD } from "MODULES/SalesOrders/constants";
import ActionDropDown from "MODULES/shared/components/ActionDropDown/ActionDropDown";
import ReleaseAccountingHold from "MODULES/ManagedRepairOrders/Detail/ReleaseAccountingHold/ReleaseAccountingHold";
import * as actions from "MODULES/ManagedRepairOrders/actions";
import { properCase } from "LIB/formatters/text";
import EditInvoiceDetails from "MODULES/ManagedRepairOrders/Detail/EditInvoiceDetails";
import ToggleQuickbooksSync from "MODULES/ManagedRepairOrders/Detail/ToggleQuickbooksSync/ToggleQuickbooksSync";
import Sync from "./Sync/Sync";

export class Header extends React.Component {
  state = {
    sendOrderModalOpen: false,
    cancelOrderModalOpen: false,
    cancellationReason: CANCELLATION_REASONS[0].value
  };

  onConfirmToRemoveAcctgHold = () => {
    const { dispatch } = this.props;

    dispatch(actions.update({ accounting_hold: false }));
  };

  openCancelOrderModal = () => this.setState({ cancelOrderModalOpen: true });
  closeCancelOrderModal = () => this.setState({ cancelOrderModalOpen: false });

  render() {
    const { managedRepairOrder } = this.props;

    return (
      <div className="page-header page-header-bar">
        <h1>
          <div className="btn-group pull-right" style={{ marginLeft: 20 }}>
            <ActionDropDown
              menuClass="dropdown-menu-right"
              style={{ cursor: "pointer" }}
            >
              <ReleaseAccountingHold
                onConfirm={this.onConfirmToRemoveAcctgHold}
                managedRepairOrder={managedRepairOrder}
              />
              <EditInvoiceDetails managedRepairOrder={managedRepairOrder} />
              <ToggleQuickbooksSync managedRepairOrder={managedRepairOrder} />
              <Sync managedRepairOrder={managedRepairOrder} />
            </ActionDropDown>
          </div>
          <RecordPager
            baseUrl="/managed-repair-orders"
            record={managedRepairOrder}
          />
          &nbsp;
          <span className="header-content">{managedRepairOrder.get(CODE)}</span>
          &nbsp;
          <ClipboardCopy name={managedRepairOrder.get(CODE)} type="RO" />
          <span className="small text-muted">
            Created {shortDate(managedRepairOrder.get(CREATED_AT))}
          </span>
          <span className="pull-right">
            {managedRepairOrder.get(ACCOUNTING_HOLD) && (
              <StatusTag
                title="Accounting Hold"
                icon="pause"
                display="warning"
              />
            )}
            {managedRepairOrder
              .get(LINE_ITEMS)
              .some(f => f.get("return_to_customer_without_repairing")) && (
              <StatusTag icon="undo" title="Returned To Customer" />
            )}
            {managedRepairOrder.get(LINE_ITEMS).some(f => f.get(CANCELLED)) && (
              <StatusTag icon="ban" title={properCase(CANCELLED)} />
            )}
            <span className="small text-muted">
              {managedRepairOrder.get(LINE_ITEMS, []).size} Item(s)
            </span>
            &nbsp;&nbsp;&nbsp;Total: {dollars(managedRepairOrder.get("total"))}
          </span>
        </h1>
      </div>
    );
  }
}

export default connect(state => ({
  id: state.mroDetail.getIn(["managedRepairOrder", "id"])
}))(Header);

Header.propTypes = {
  managedRepairOrder: PropTypes.shape({}),
  dispatch: PropTypes.func
};



// WEBPACK FOOTER //
// ./app/modules/ManagedRepairOrders/Detail/Header.jsx